<div class="code-viewer">
  <div #editorContainer class="editor-container"></div>
  @if (loading) {
    <div class="editor-state">Carregando editor...</div>
  }
  @if (loadFailed) {
    <pre class="editor-fallback">{{ content }}</pre>
  }
</div>
